import { CircleDotDashed, LockKeyhole, Radar, ShieldCheck } from "lucide-react";

import { XOLogo } from "../components/XOLogo";

export const SignInPage = ({ error, onSignIn }: { error?: string | null; onSignIn: () => void }) => (
  <main className="xo-signin">
    <div className="xo-signin__orbits" />
    <section>
      <XOLogo />
      <h1>Your operational world,<br />held in view.</h1>
      <p>XO is your private executive officer: working memory, attention intelligence, and evidence for the next decision.</p>
      <div className="signin-features">
        <span><Radar /><strong>See what needs you</strong><small>Across focused personal and work sources</small></span>
        <span><CircleDotDashed /><strong>Know why it matters</strong><small>Facts, inference, judgement, and evidence</small></span>
        <span><ShieldCheck /><strong>Stay in command</strong><small>Read intelligence with no autonomous writes</small></span>
      </div>
      <button onClick={onSignIn} type="button"><LockKeyhole /> Continue with the owner account</button>
      {error ? <p className="panel-error">{error}</p> : null}
      <small>Restricted to Andrés. Connector accounts do not grant XO app access.</small>
    </section>
  </main>
);
